import type { ReactNode } from "react";
import { hasSiteBuilderBlocks } from "./SiteBuilderContent";
import type {
    ResolvedTemplateDesign,
    TemplateLinkComponent,
    TemplateRenderProps,
} from "./types";
import { WebBuilderRegionStyles } from "./WebBuilderRegionStyles";
import { WebSiteBuilderContent } from "./WebSiteBuilderContent";

export function WebBuilderPageRegion({
    design,
    fallback,
    LinkComponent,
    props,
}: {
    design: ResolvedTemplateDesign;
    fallback?: ReactNode;
    LinkComponent: TemplateLinkComponent;
    props: TemplateRenderProps;
}) {
    const document = props.page?.contentJson ?? null;

    if (!hasSiteBuilderBlocks(document)) {
        return fallback ?? null;
    }

    return (
        <>
            <WebBuilderRegionStyles />
            <main
                data-builder-document-region="page"
                data-web-builder-region="page"
            >
                <WebSiteBuilderContent
                    bookingDemoData={props.bookingDemoData}
                    contentJson={document}
                    design={design}
                    editorMode={Boolean(props.editorMode)}
                    headerActions={props.headerActions}
                    leadForm={props.leadForm}
                    leadForms={props.leadForms}
                    LinkComponent={LinkComponent}
                    menus={props.menus}
                    navigationReadOnly={props.navigationReadOnly}
                    page={props.page}
                    pages={props.pages}
                    readOnly={props.readOnly}
                    site={props.site}
                />
            </main>
        </>
    );
}
